/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { ajax, Status, arrayFrom, sortFn, publish, parseDate, fmt } from '../../twd'

export default ({acctNo}) => {
    const [status, setStatus] = React.useState(Status.LOADING)
    const [accounts, setAccounts] = React.useState([])
    const [holdings, setHoldings] = React.useState([])
    const [account, setAccount] = React.useState(acctNo)

    const lastAbort = React.useRef()

    React.useEffect(() => {

        ;(async () => {
            setStatus(Status.LOADING)

            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                let {data, abort} = ajax({
                    url: '/esb/retailservice/holdingAndAlertDataService/getUserHoldings',
                    method: 'GET'
                })

                lastAbort.current = abort
                let rs = await data
                lastAbort.current = null

                let accts = arrayFrom(rs.accounts)
                    .filter(a => a.title && a.title.trim())
                    .sort(sortFn((a) => a.title.trim()))

                setAccounts(accts)
                setAccount(account || (accts[0] || {}).acctNo)
                let holdings  = arrayFrom(rs.holdings)
                    .map(a => {
                        let m = a.maturity
                        if (!m) return a

                        let d = new Date(m)
                        if (!isNaN(d)) {
                            a.maturity = fmt.mdy(d)
                        }
                        return a
                    })
                    .filter(({maturity}) => {
                        const isMatured = parseDate(maturity) < Date.now()
                        return !isMatured
                    })
                    .sort(sortFn(({issue, maturity}) => {
                        return `${(issue || '').trim()}-${fmt.fmtDt(parseDate(maturity), 'yyyy-MM-dd')}`
                    }))
                setHoldings(holdings)

                setStatus(Status.LOADED)
                setTimeout(() => {
                    publish('user-holdings', rs)
                })
            } catch(e) {
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

        return () => {
            if (lastAbort.current) {
                lastAbort.current()
            }
        }
    }, [])

    return {
        status,
        accounts, holdings,
        account, setAccount,
    }
}